import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const FillIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1" y="1" width="13" height="13" fill={color} fillOpacity="0.4" />
    </svg>
  );
});
